import { Skeleton } from '@reveni-io/reveni-ui'

import * as Styles from './styles'

const EmailPreview = ({ fetching, preview }) => {
  if (fetching || !preview) {
    return (
      <Styles.Area>
        <Skeleton variant="rounded" width="100%" height="100%" />
      </Styles.Area>
    )
  }

  return (
    <Styles.Area>
      <Styles.Container>
        <Styles.Iframe srcDoc={preview} title="Email preview" sandbox="allow-same-origin" />
      </Styles.Container>
    </Styles.Area>
  )
}

export default EmailPreview
